import { Map, List } from 'immutable';

import {
  COGNITO_FORM_LIST_REQUEST,
  COGNITO_FORM_LIST_SUCCESS,
  COGNITO_FORM_LIST_FAILURE,
  COGNITO_FORM_READ_REQUEST,
  COGNITO_FORM_READ_SUCCESS,
  COGNITO_FORM_READ_FAILURE,
  COGNITO_FORM_UPDATE_REQUEST,
  COGNITO_FORM_UPDATE_SUCCESS,
  COGNITO_FORM_UPDATE_FAILURE,
  COGNITO_FORM_CREATE_REQUEST,
  COGNITO_FORM_CREATE_SUCCESS,
  COGNITO_FORM_CREATE_FAILURE,
  COGNITO_FORM_DELETE_REQUEST,
  COGNITO_FORM_DELETE_SUCCESS,
  COGNITO_FORM_DELETE_FAILURE,
  COGNITO_FORM_FORM_DESTROY,
  COGNITO_FORM_CSV_DOWNLOAD_REQUEST,
  COGNITO_FORM_CSV_DOWNLOAD_SUCCESS,
  COGNITO_FORM_CSV_DOWNLOAD_FAILURE,
} from './actions';
import Logger from '../../../lib/Logger';

export default function cognitoForms(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    'debug',
    `[cognitoForms.reducers] cognitoForms(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case COGNITO_FORM_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case COGNITO_FORM_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case COGNITO_FORM_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case COGNITO_FORM_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case COGNITO_FORM_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case COGNITO_FORM_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case COGNITO_FORM_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case COGNITO_FORM_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case COGNITO_FORM_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case COGNITO_FORM_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case COGNITO_FORM_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case COGNITO_FORM_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case COGNITO_FORM_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case COGNITO_FORM_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case COGNITO_FORM_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case COGNITO_FORM_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set('form', action.form);

    case COGNITO_FORM_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case COGNITO_FORM_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case COGNITO_FORM_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `cognitoForms.reducers loaded.`);
